var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgForwardCurve(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.8805 7.70815L18.3205 9.14815L13.4405 14.0282L10.1505 10.7382C9.76046 10.3482 9.13046 10.3482 8.74046 10.7382L2.74046 16.7482C2.35046 17.1382 2.35046 17.7682 2.74046 18.1582C3.13046 18.5482 3.76046 18.5482 4.15046 18.1582L9.44046 12.8582L12.7305 16.1482C13.1205 16.5382 13.7505 16.5382 14.1405 16.1482L19.7305 10.5682L21.1705 12.0082C21.4805 12.3182 22.0205 12.0982 22.0205 11.6582V7.35815C22.0305 7.07815 21.8105 6.85815 21.5305 6.85815H17.2405C16.7905 6.85815 16.5705 7.39815 16.8805 7.70815Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgForwardCurve);
export default __webpack_public_path__ + "static/media/forward-curve.101d32e6.svg";
export { ForwardRef as ReactComponent };